module.exports = "/_next/static/images/join-xtimes-airdrop-en-15cfd9fe0810750362ef2375f004aa91.png";